import { Component, OnInit } from '@angular/core';
import { Text_lois } from 'model/modal-cms/text_lois';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';

@Component({
  selector: 'app-detail-text',
  templateUrl: './detail-text.component.html',
  styleUrls: ['./detail-text.component.scss']
})
export class DetailTextComponent implements OnInit {
  text_lois: Text_lois = new Text_lois(null);
  id: any;
  constructor(public activatedRoute: ActivatedRoute, private router: Router, public cmsService: CMSService) {
    this.id = activatedRoute.snapshot.params['id'];}

  ngOnInit() {
    this.getInfotText();
  }

  getInfotText() {
    this.cmsService.getDetailText(this.id)
      .subscribe(data => {
        this.text_lois = data
      },
        err => {
          console.log(err);
        })
  }

}
